import * as t from 'io-ts'

export const PatientCodec = t.type({
    firstName: t.string,
    lastName: t.string,
    bid: t.string
});

export const MemberCodec = t.intersection(
    [
        t.type({
            name: t.string
        }),
        t.partial({
            free: t.boolean,
            warning: t.string
        })
    ]);

export const GroupCodec = t.intersection(
    [
        t.type({
            label: t.string,
            members: t.array(MemberCodec)
        }),
        t.partial({
            color: t.string
        })
    ]);

export const GroupsCodec = t.array(GroupCodec);

export const DataCodec = t.intersection(
    [
        t.type({
            allocations: GroupsCodec
        }),
        t.partial({
            allocated: GroupsCodec,
            patient: PatientCodec,
        })
    ]);

export const ApiResponseOkCodec = t.type({
    result: DataCodec
});


